export enum DeclarationType {
  EmployeeFitAndProperDeclaration = 'EmployeeFitAndProperDeclaration',
  ExternalBusinessInterestDeclaration = 'ExternalBusinessInterestDeclaration',
  PersonalAccountDealingDeclaration = 'PersonalAccountDealingDeclaration',
  Smcr = 'Smcr',
  StatementOfResponsibilities = 'StatementOfResponsibilities'
}
